import React from 'react';
import { fmtMetrica } from '../../lib/venduto';
import { cn } from '../../lib/utils';

/**
 * Tabella metriche: una colonna per servizio ordinario + colonna Totale.
 */
export const MetricheTable = ({ dati, testid = 'metriche-table' }) => {
  if (!dati) return null;
  const colonne = [...dati.servizi, dati.totale];

  return (
    <div className="overflow-x-auto -mx-4 px-4" data-testid={testid}>
      <table className="w-full text-xs border-separate border-spacing-0">
        <thead>
          <tr>
            <th className="sticky left-0 z-10 bg-card text-left p-2 border-b border-border font-semibold">
              Metrica
            </th>
            {colonne.map((c) => (
              <th
                key={c.servizio}
                className={cn(
                  'p-2 text-right border-b border-border font-semibold whitespace-nowrap',
                  c.servizio === 'totale' && 'bg-accent text-accent-foreground'
                )}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dati.metriche_def.map((m) => (
            <tr key={m.key} className="odd:bg-secondary/40">
              <td className="sticky left-0 z-10 bg-inherit p-2 border-b border-border/60 text-muted-foreground">
                {m.label}
              </td>
              {colonne.map((c) => (
                <td
                  key={c.servizio + m.key}
                  data-testid={`${testid}-${m.key}-${c.servizio}`}
                  className={cn(
                    'p-2 text-right border-b border-border/60 font-mono-numbers whitespace-nowrap',
                    c.servizio === 'totale' && 'bg-accent/60 font-semibold'
                  )}
                >
                  {fmtMetrica(c[m.key], m.tipo)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MetricheTable;
